import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';

import { signOut } from 'aws-amplify/auth';

import { AuthService } from '../../../auth/auth.service';
import { TokensService } from '../../../shared/services/tokens.service';
import { MediaService } from '../../../shared/services/media.service';
import { ChatStateService } from '../../../shared/services/chat-state.service';
import { WebsocketService } from '../../../shared/services/websocket.service';
import { ProfileStateService } from '../../../shared/services/profile-state.service';

import { ChatFacade } from '../../../store/chat';

import { SvgIconComponent } from 'app/shared/components/svg-icon/svg-icon.component';

import { ISvgConfig } from 'app/shared/interfaces/svg.interfaces';

import { ESvgTypes } from 'app/shared/enums/svg.enums';
import { ELocalStorageKey } from 'app/shared/enums/shared.enums';
import { ETermsOfService } from '../../../enums/terms-of-service.enums';

@Component({
  selector: 'stxt-support',
  standalone: true,
  imports: [CommonModule, SvgIconComponent],
  templateUrl: './support.component.html',
  styleUrl: './support.component.scss'
})
export class SupportComponent {
  @Output() logoutEvent: EventEmitter<void> = new EventEmitter<void>();
  public arrowSvgConfig: ISvgConfig = { name: 'arrow-ne-outlined', fill: ESvgTypes.None };
  public tosLink: string = ETermsOfService.TermsOfUse;
  public helpCenterLink: string = ETermsOfService.HelpCenter;
  protected readonly window = window;
  private readonly localStorageKeys: string[] = [
    ELocalStorageKey.AccessToken,
    ELocalStorageKey.CognitoAccessToken,
    ELocalStorageKey.CreatorInfo,
    ELocalStorageKey.BackUrl,
    ELocalStorageKey.User,
    ELocalStorageKey.UserId,
    ELocalStorageKey.ProfileOpened,
    ELocalStorageKey.ProfileCompleted,
    ELocalStorageKey.LastActiveConversationId
  ];
  public links: { name: string; link: string }[] = [
    { name: 'Terms of use', link: this.tosLink },
    { name: 'Help center', link: this.helpCenterLink }
  ];

  constructor(
    private authService: AuthService,
    private readonly router: Router,
    private readonly tokensService: TokensService,
    private readonly mediaService: MediaService,
    private readonly chatStateService: ChatStateService,
    private readonly websocketService: WebsocketService,
    private readonly profileStateService: ProfileStateService,
    private readonly chatFacade: ChatFacade
  ) {}

  async logOut(): Promise<void> {
    try {
      this.chatStateService.cleanup();
      this.websocketService.cleanup();
      this.chatFacade.clearConversations();

      this.profileStateService.clearProfileData();
      this.tokensService.tokensBalanceSubject.next(null);

      await signOut().then(() => {
        this.localStorageKeys.forEach(key => localStorage.removeItem(key));

        this.authService.currentSession();
        this.authService.userLoaded$.next(false);
        this.mediaService.clearMediaCache();

        this.logoutEvent.emit();

        this.router.navigate(['/']);
      });
    } catch (error) {
      this.chatStateService.cleanup();
      this.websocketService.cleanup();
      this.chatFacade.clearConversations();
      this.localStorageKeys.forEach(key => localStorage.removeItem(key));
      this.router.navigate(['/']);
    }
  }
}
